import '@babel/runtime-corejs3/core-js/parse-int';
import '@babel/runtime-corejs3/core-js/instance/concat';
import { mobile } from '@bilibili-maoer/web-utils';
import { isSupport, biliBridge } from '@bilibili/js-bridge';
import { MISSEVAN_BILI_PREFIX_URL } from '../constant.js';

/**
 * 用啊 b 的 JSB 打开指定 URL
 *
 * @param url 要打开的页面的 URL
 * @param onFailed 打开失败时的回调函数
 */

function biliOpenScheme(url, onFailed) {
  var method = mobile.isIOS() ? 'ability.openScheme' : 'bbq.openWithBrowser';
  isSupport(method).then(function (supported) {
    if (supported) {
      biliBridge.callNative({
        method: method,
        data: {
          url: url
        },
        callback: function callback(res) {
          if ((res === null || res === void 0 ? void 0 : res.code) !== 0 && onFailed) {
            onFailed();
          }
        }
      });
    } else {
      // goto download page
      window.location.href = "".concat(MISSEVAN_BILI_PREFIX_URL, "/lite/#");
    }
  });
}
/**
 * 检查指定包名的应用是否已安装。
 *
 * 此项功能只在 Android 上可用，在 iOS 上不支持。
 *
 * @param packageName 包名
 * @param onSupported 如果 JSB 支持该方法，会调用此回调函数
 * @param onUnsupported 如果 JSB 不支持检查应用安装情况，会调用此回调函数
 */

function biliIsInstall(packageName, onSupported, onUnsupported) {
  isSupport('bbq.isInstalled').then(function (supported) {
    if (supported) {
      biliBridge.callNative({
        method: 'bbq.isInstalled',
        data: {
          packageName: packageName
        },
        callback: function callback(res) {
          onSupported(res);
        }
      });
    } else if (onUnsupported) {
      onUnsupported();
    }
  });
}

export { biliIsInstall, biliOpenScheme };
